import { render, staticRenderFns } from "./McMenu.vue?vue&type=template&id=0e8ffac0&scoped=true"
import script from "./McMenu.vue?vue&type=script&lang=js"
export * from "./McMenu.vue?vue&type=script&lang=js"
import style0 from "./McMenu.vue?vue&type=style&index=0&id=0e8ffac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@osgfe/builder-plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8ffac0",
  null
  
)

export default component.exports